import FirebaseService from "./FirebaseService";
import Firebase from "../../Firebase";
import ISettingsService from "../../spi/ISettingsService";
import ILookup from "../../../types/ILookup";


export default class FirebaseSettingsService implements ISettingsService {


    async getLookupForType(lookupType: string): Promise<Array<ILookup>> {
        let lookups: Array<ILookup> = [];
        const snapshot = await FirebaseService.getInstance()
                                .lookupSetting(lookupType)
                                .get();
                                debugger;
        if(snapshot.exists){
            snapshot.forEach((child:any) => {
                const key = child.id;
                const val = child.data();
                lookups.push({
                    id: key,
                    name: val.name,
                    value: val.value,
                    description: val.description,
                    isActive: val.isActive
                });        
            });
        }
        return lookups;
    }    
    
    async createLookupRow(lookupType: string, lookupValue: string): Promise<ILookup> {
        const newLookup: ILookup = {
            name: lookupType,
            value: lookupValue,
            description: '',
            isActive: true
        };
        try{
            await FirebaseService.getInstance().lookupSetting(lookupType).set(newLookup);
        }catch(e){
            throw e;
        }
        return newLookup;
    }
    
    async updateLookup(lookup: ILookup): Promise<Boolean> {
        try{
            await FirebaseService.getInstance().lookupSetting(lookup.name).update(lookup);
        }catch(e){
            throw e;
        }
        return true;
    }
    
    async deleteLookup(lookup: ILookup): Promise<Boolean> {
        try{
            await FirebaseService.getInstance().lookupSetting(lookup.name).delete();
        }catch(e){
            throw e;
        }
        return true;
    }
    
    datasource?: any;

    
}